//
//
//
//
//
//
//
//

import { conversion } from "@/tool";
export default {
  props: {
    price: {
      type: Number,
    },
    stringValue: {
      type: [String, Number],
    },
  },
  filters: {
    conversion,
  },
};
